export default __webpack_public_path__ + "75824cb7237e60f40b77bb3ab0b12f4b.png";